import {
    Params,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
  } from '@angular/router';

  import { createFeatureSelector } from '@ngrx/store';

  import * as fromRouter from '@ngrx/router-store';

export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
  }

  export class CustomSerializer
    implements fromRouter.RouterStateSerializer<RouterStateUrl> {
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
      const { url } = routerState;
      const { queryParams } = routerState.root;

      let state: ActivatedRouteSnapshot = routerState.root;
      let params: Params = state.params;

      // collect all params (e.g. patientId) down the tree
      while (state.firstChild) {
        if (state.params) {
          params = {
            ...state.params,
            ...params
          };
        }
        state = state.firstChild;
      }
      if (state.params) {
        params = {
          ...state.params,
          ...params
        };
      }

      return { url, queryParams, params };
    }
  }

  export const getRouterState = createFeatureSelector<
    fromRouter.RouterReducerState<RouterStateUrl>
  >('routerReducer');
